import React from 'react';

const Icon = ({ width = '49', height = '48', fill = 'white', ...other }) => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="8" stroke="white" strokeWidth="2" />
            <g id="Repeat group 1_inner" data-figma-trr="r5u2.5-0f">
                <path
                    d="M31.7886 15.0497C29.5471 12.7787 26.7886 11.0849 23.7493 10.1133C20.71 9.14176 17.4804 8.9214 14.3373 9.47112C16.0733 7.02408 18.2236 4.89927 20.6912 3.19258C23.6772 3.72722 26.4602 5.06821 28.7391 7.07046C31.018 9.07272 32.7059 11.66 33.6204 14.5524C32.9937 14.6632 32.3831 14.8234 31.7886 15.0497Z"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinejoin="round"
                />
            </g>
            <use xlinkHref="#Repeat%20group%201_inner" transform="translate(37.7669 -5.98169) rotate(72)" />
            <use xlinkHref="#Repeat%20group%201_inner" transform="translate(55.1265 28.0883) rotate(144)" />
            <use xlinkHref="#Repeat%20group%201_inner" transform="translate(28.0883 55.1265) rotate(-144)" />
            <use xlinkHref="#Repeat%20group%201_inner" transform="translate(-5.98169 37.7669) rotate(-72)" />
        </svg>
    );
};
export default React.memo(Icon);
